import ContentAdd from '@mui/icons-material/Add';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useResourceContext } from 'react-admin';
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from 'shared/mui/Buttons';

type Props = {
  target?: React.HTMLAttributeAnchorTarget;
};

export type CreateButtonProps = ButtonProps & Props;

export function CreateButton(props: CreateButtonProps): JSX.Element {
  const {
    label,
    startIcon = <ContentAdd />,
    size = 'medium',
    variant = 'contained',
    ...rest
  } = props;
  const translate = useTypedTranslate();
  const resource = useResourceContext(props);
  const { createPathWithQuery } = useCreatePathWithQuery();

  return (
    <Button
      component={Link}
      label={label || translate('app.buttons.add')}
      size={size}
      startIcon={startIcon}
      to={createPathWithQuery({ resource, type: 'create' })}
      variant={variant}
      {...rest}
    />
  );
}
